var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#B2B2B2"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M5.171.8h8c2.21 0 4 1.79 4 4v8c0 2.21-1.79 4-4 4h-8a4 4 0 01-4-4v-8a4 4 0 014-4z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 1.8,
    d: "M9.171 16.3v-7"
  }))));
}
export default SvgIcLogout;